import SiteMessagesInstance from '../../components/site-messages'

// The connection step for a plain browser (no app bridge). Two ways in:
//  - Bluetooth, when the browser has Web Bluetooth (Chrome/Edge on a
//    computer, Chrome on Android): a click opens the browser's device
//    chooser and the rest of the flow runs over that link.
//  - the "dumb" Wi-Fi mode: the user joins the sensor's network by hand and
//    opens its setup page directly. Not offered on sites that say they
//    can't do it (window.site.canOnboard false).
export class StepStartBrowser {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "start_browser";
  title = "Set up a Temp Stick";

  template = `
  <div class="onboarding-step" data-for="start_browser">

    <!-- Beta testers: why this browser gets no Bluetooth option -->
    <div class="onboarding-ble-note" style="display: none;"></div>

    <div class="onboarding-ble-browser" style="display: none;">

      <p class="onboarding-guide-instruction">
        Put your Temp Stick in <b>setup mode</b>, keep it near this computer, then click below and pick it from the
        list your browser shows.
      </p>

      <div class="onboarding-scan-qr-code">
        <button type="button" class="button button--medium" data-for="start_browser_ble">
          Connect with Bluetooth
        </button>
      </div>

      <p class="onboarding-guide-instruction-smaller">
        Needs a computer or Android device with Bluetooth, in Chrome or Edge.
      </p>

    </div>

    <div class="onboarding-ble-browser-divider text-divider" style="display: none;">
      <div class="text-divider__text">OR</div>
    </div>

    <div class="onboarding-wifi-browser">

      <p class="onboarding-guide-instruction">
        Go to the <b>WiFi settings</b> of this device and connect to the WiFi network named <b>Sensor Setup</b> and click the button below.
      </p>

      <p class="onboarding-guide-instruction-smaller">
        Your Temp Stick creates this temporary network so that it can connect directly with your device to finish setup.
      </p>

      <div class="onboarding-scan-qr-code">
        <a
          href="http://10.10.1.1"
          target="_blank" onclick="window.open('http://10.10.1.1', 'newwindow', 'width=800, height=600'); return false;"
          class="button button--medium"
        >
          I'm Connected to the "Sensor Setup" WiFi Network
        </a>
      </div>

      <p class="onboarding-guide-instruction">
        You will be sent to our sensor's setup page.  If the setup page doesn't load, double check you are
        connected to the <b>Sensor Setup</b> network on your device and try again.
      </p>

    </div>

    ${!window.site.isApp ? `

    <div class="divider"></div>

    <p class="onboarding-guide-instruction">
      Download our free app on your phone or tablet for an easier setup of your Temp Stick.
    </p>

    <div class="onboarding-browser-app-links">
      <div class="onboarding-browser-app-links__link">
        <a href="https://play.google.com/store/apps/details?id=com.tempstick" target="_blank">
          <img src="${window.site.home}/../assets/images/app-stores-google-play.png" width="200" title="Android app" />
        </a>
      </div>
      <div class="onboarding-browser-app-links__link">
        <a href="https://apps.apple.com/us/app/temp-stick/id1137756208" target="_blank">
          <img src="${window.site.home}/../assets/images/app-stores-apple.png" width="200" title="iOS app" />
        </a>
      </div>
    </div>
    ` : ``}

  </div>
  `;

  onBack = () => {
    window.location.href = window.site.home + '/sensors';
  }

  onActivate = () => {

    const offerBle = !!this.onboarding.bleBridge() && this.onboarding.transportPreference() !== 'wifi';
    const offerWifi = window.site.canOnboard !== false;

    this.$ble.toggle(offerBle);
    this.$divider.toggle(offerBle && offerWifi);
    this.$wifi.toggle(offerWifi);

    this.$bleBtn.prop('disabled', false).text('Connect with Bluetooth');

    const note = offerBle ? '' : this.onboarding.webBleUnavailableNote();
    this.$bleNote.html(note).toggle(note.length > 0);

  }

  bindActions = () => {

    const $step = $(this.onboarding.container).find('.onboarding-step[data-for="start_browser"]');

    this.$ble = $step.find('.onboarding-ble-browser');
    this.$bleNote = $step.find('.onboarding-ble-note');
    this.$divider = $step.find('.onboarding-ble-browser-divider');
    this.$wifi = $step.find('.onboarding-wifi-browser');
    this.$bleBtn = $step.find('button[data-for="start_browser_ble"]');

    // Has to stay a direct click handler: the browser only opens its device
    // chooser inside a user gesture.
    this.$bleBtn.on('click', () => this.connectBle());

  }

  async connectBle() {

    this.$bleBtn.prop('disabled', true).text('Choose your Temp Stick...');

    const res = await this.onboarding.Temp_Stick_Connect_Ble({
      sensorId: this.onboarding.sensorId || '',
      timeoutMs: 20000
    });

    this.$bleBtn.prop('disabled', false).text('Connect with Bluetooth');

    if (!res.success) {

      if (res.code === 'CANCELLED') {
        return;
      }

      SiteMessagesInstance.addMessage('error', this.failureMessage(res));
      SiteMessagesInstance.displayMessages();
      return;

    }

    // Same hand-off as after a QR scan in the app: the connecting step starts
    // the heartbeat, which identifies the sensor over the new link.
    this.onboarding.sensorId = res.sensorId || this.onboarding.sensorId;
    this.onboarding.manual_connect = false;
    this.onboarding.goToStep('attempt_to_connect');

  }

  failureMessage(res) {

    switch (res && res.code) {
      case 'PERMISSION':
        return 'The browser blocked Bluetooth access. Allow it for this site and try again.';
      case 'UNAVAILABLE':
        return "This browser can't use Bluetooth. Try Chrome or Edge, or set the sensor up in the app.";
      case 'WRONG_SENSOR':
        return (res.message || 'That is a different Temp Stick') + '. Pick the one you are setting up.';
      case 'TIMEOUT':
        return "We couldn't reach the Temp Stick over Bluetooth. Make sure it's in setup mode and close by, then try again.";
      default:
        return (res && res.message) ? res.message : "We couldn't connect over Bluetooth, please try again.";
    }

  }

}
